import React from 'react';
import FeatherIcon from 'feather-icons-react';

const STATUS_ICON = {
  pass: 'check-circle',
  warn: 'alert-triangle',
  fail: 'x-circle',
};

function statusClass(status) {
  return `seo-score-status--${status}`;
}

/**
 * Expandable breakdown of the SEO anatomy score. Lists each of the 10 anatomy
 * sections with its pass/warn/fail status and the individual checks behind it.
 */
export default function SeoScoreDetails({ score }) {
  if (!score) return null;

  const passing = score.sections.filter((s) => s.status === 'pass').length;
  const total = score.sections.length;

  return (
    <div className="seo-score-details" role="region" aria-label="SEO score breakdown">
      <div className="seo-score-details__header">
        <div className="seo-score-details__headline">
          <span className="seo-score-details__overall">{score.overall}</span>
          <span className="seo-score-details__overall-max">/100</span>
        </div>
        <p className="seo-score-details__summary">
          {passing} of {total} anatomy sections passing
        </p>
      </div>

      <ul className="seo-score-section-list">
        {score.sections.map((section) => (
          <li key={section.id} className="seo-score-section">
            <details>
              <summary className="seo-score-section__summary">
                <FeatherIcon
                  icon={STATUS_ICON[section.status]}
                  width="16px"
                  height="16px"
                  className={`seo-score-status ${statusClass(section.status)}`}
                />
                <span className="seo-score-section__title">{section.title}</span>
                <span className="seo-score-section__score">
                  {Math.round(section.score)}/{section.maxScore}
                </span>
                <FeatherIcon icon="chevron-down" width="14px" height="14px" className="seo-score-section__chevron" />
              </summary>
              <ul className="seo-score-check-list">
                {section.checks.map((check) => (
                  <li key={check.id} className="seo-score-check">
                    <FeatherIcon
                      icon={STATUS_ICON[check.status]}
                      width="13px"
                      height="13px"
                      className={`seo-score-status ${statusClass(check.status)}`}
                    />
                    <div className="seo-score-check__body">
                      <span className="seo-score-check__label">{check.label}</span>
                      <span className="seo-score-check__detail">{check.detail}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </details>
          </li>
        ))}
      </ul>

      <p className="seo-score-details__footnote">
        Scores are estimated from the post structure. Keyword and tone signals are approximated, so
        treat this as guidance rather than a guarantee.
      </p>
    </div>
  );
}
